import { translateBlock } from 'i18n';
import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';

type Props = {
    finalIndicator?: string;
    finalAmountFormatted?: string;
    finalAmountWithReportFormatted?: string;
    isReportedAmountUsed: boolean;
};

const StyFinalIndicator = styled('div', {
    name: 'StyFinalIndicator',
})({
    margin: '2rem',
    marginLeft: '1rem',
    display: 'flex',
    flexDirection: 'column',
});

const StyColoredText = styled(Typography, {
    name: 'StyColoredText',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: 'bold',
}));

export default function BudgetBalanceTableFooter({
    finalIndicator = '',
    finalAmountFormatted = '',
    finalAmountWithReportFormatted = '',
    isReportedAmountUsed,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    if (isReportedAmountUsed) {
        return (
            <StyFinalIndicator>
                <Typography>
                    {translateBlock(finalIndicator).toUpperCase()} :{' '}
                    {finalAmountFormatted}
                </Typography>
                <StyColoredText>
                    {t('budgetOverview.totalWithReports').toUpperCase()} :{' '}
                    {finalAmountWithReportFormatted}
                </StyColoredText>
            </StyFinalIndicator>
        );
    }
    return (
        <StyFinalIndicator>
            <StyColoredText>
                {translateBlock(finalIndicator).toUpperCase()} :{' '}
                {finalAmountFormatted}
            </StyColoredText>
        </StyFinalIndicator>
    );
}
